import { render } from "./ViewProfile.vue?vue&type=template&id=5f584ce1&scoped=true"
import script from "./ViewProfile.vue?vue&type=script&lang=js"
export * from "./ViewProfile.vue?vue&type=script&lang=js"

import "./ViewProfile.vue?vue&type=style&index=0&id=5f584ce1&scoped=true&lang=css"

import exportComponent from "/var/www/mkssg/mkssg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f584ce1"]])

export default __exports__